import "./WorkingProcess.css";
import SectionHeading3 from "../SectionHeadings/Heading3/SectionHeading3";
import {workingProcessData} from "../../constants/WorkingProcess";

const WorkingProcess = () => {
  return (
    <section className="section">
      <div className="working-process-container container">
        <SectionHeading3
          title="My Easy Working Process"
          description="From kickoff to delivery, my process is built to be smooth, transparent, and effective. It ensures every project runs efficiently, with clear communication and thoughtful execution at every step."
        />
        <div className="working-process-component">
          <div className="working-process-wrapper">
            {workingProcessData.map((step, index) => (
              <div key={index} className="working-process-item">
                <div className="working-process-number">
                  <span>{step.id}</span>
                </div>
                <div className="working-process-content">
                  <h4 className="working-process-title">{step.title}</h4>
                  <div className="working-process-paragraph">
                    {step.description}
                  </div>
                  <div className="working-process-thumb">
                    <img src={step.image} alt={step.title} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkingProcess;
